module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_kuribayashi-b0c4982c8e6d068137b3f4dc017e20f6.jpg";